import React, { useState } from "react";
import Button from "../../components/ui/button";
import { navLogo } from "../../assets";
import { useNavigate } from "react-router-dom";
import {
  FaBars as MenuIconReact,
  FaTimes as CloseIconReact,
} from "../../components/icons"; // Import your react-icon wrappers

const Navbar = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const navTabs = ["Home", "About Us", "Contact Us", "Get Appointment"];
  // const navTabs = ["Home", "About Us", "Categories"];

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  return (
    <div className="relative">
      <div className="flex justify-between items-center mx-4 sm:mx-8 md:mx-10 lg:mx-[4rem] my-3 sm:my-4 md:my-[1.25rem] py-3 rounded-lg">
        <img src={navLogo} className="h-8 sm:h-10 md:h-12" alt="Ubimed Logo" />

        <div className="hidden md:flex gap-6 lg:gap-[2rem]">
          {navTabs.map((tab, index) => (
            <div
              key={tab}
              onClick={() => {
                setActiveTab(index);
                // Add navigation based on tab clicked
                if (tab === "Home") navigate("/");
                if (tab === "About Us") navigate("/about");
                if (tab === "Contact Us") navigate("/help");
                if (tab === "Get Appointment") navigate("/get-appointment");
              }}
              className={`font-lato text-base lg:text-[1.125rem] font-normal cursor-pointer ${
                activeTab === index ? "text-green-500" : "text-[#F1F1F1]"
              }`}
            >
              {tab}
            </div>
          ))}
        </div>
        <Button
          text="Log In"
          theme="primary"
          className="hidden md:block px-6 lg:px-[2rem] py-2 lg:py-[1rem] rounded-md lg:rounded-[0.5rem] text-sm lg:text-base"
          onClick={() => navigate("/login")}
        />

        <div className="md:hidden">
          <button
            onClick={toggleMobileMenu}
            className="text-white focus:outline-none"
          >
            {/* Use react-icons wrappers. Pass size and color props as needed. */}
            {isMobileMenuOpen ? (
              <CloseIconReact size={24} />
            ) : (
              <MenuIconReact size={24} />
            )}
          </button>
        </div>
      </div>

      <div
        className={`
          md:hidden overflow-hidden transition-all ease-in-out duration-300
          mx-4 rounded-b-md shadow-lg bg-gray-800 
          ${
            isMobileMenuOpen
              ? "max-h-96 opacity-100 mt-2 mb-4"
              : "max-h-0 opacity-0"
          }
        `}
      >
        <div className="flex flex-col items-center gap-4 py-4">
          {navTabs.map((tab, index) => (
            <div
              key={tab}
              onClick={() => {
                setActiveTab(index);
                setIsMobileMenuOpen(false);
                // Add navigation based on tab clicked
                if (tab === "Home") navigate("/");
                if (tab === "About Us") navigate("/about");
                if (tab === "Get Appointment") navigate("/get-appointment");
              }}
              className={`font-lato text-base font-normal cursor-pointer w-full text-center py-2 ${
                activeTab === index
                  ? "text-green-500 bg-gray-700"
                  : "text-[#F1F1F1]"
              }`}
            >
              {tab}
            </div>
          ))}

          <Button
            text="Log In"
            theme="primary"
            className="w-3/4 px-[2rem] py-[0.75rem] rounded-[0.5rem] text-sm mt-2"
            onClick={() => {
              navigate("/login");
              setIsMobileMenuOpen(false);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
